// extracted by mini-css-extract-plugin
export default {"wrapper":"_7583140b","disclaimer":"_8173685b","disclaimerEmphasis":"_cd25f943"};